exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padding-c-1 {\n\tpadding-right: 30px;\n\tpadding-left: 30px;\n}\n.btn-close-custom-modal {\n\tdisplay: flex;\n\tfont-size: 2.5rem;\n\tline-height: 1;\n\tcolor: #000;\n\ttext-shadow: 0 1px 0 #fff;\n\topacity: 0.5;\n\tborder: none;\n\tborder-color: none;\n\tappearance: none;\n\tcursor: pointer;\n\tbackground-color: transparent;\n\tborder: 0;\n}\n.custom-modal-min-width .modal-dialog {\n\tmin-width: 600px;\n}\n", ""]);

// exports
